module.exports = __webpack_public_path__ + "static/og-d4d5da68aa7647efc3929df56b96d4cf.png";